<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <!--<side-bar
      :background-color="sidebarBackground"
      short-title="IDCMN"
      title="IDCMN"      
    >
      <template  slot="links" >
        <sidebar-item
          :link="{
            name: 'Dashboard',
            icon: 'ni ni-tv-2 text-primary',
            path: '/ttn'
          }"
        />
        <sidebar-item :link="{name: 'Ca Trực', icon: 'ni ni-bullet-list-67 text-orange', path: '/events'}"/>
        <sidebar-item :link="{name: 'Lịch Trực', icon: 'ni ni-calendar-grid-58 text-yellow', path: '/profile'}"/>
        <sidebar-item :link="{name: 'Tổ Chức', icon: 'ni ni-planet text-blue', path: '/organizations'}"/>
        <sidebar-item :link="{name: 'Cá Nhân', icon: 'ni ni-single-02 text-blue', path: '/tenants'}"/>
      </template>
    </side-bar> -->
    <div class="main-content" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>

      <div @click="toggleSidebar">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>

      </div>
    </div>
  </div>
</template>
<script>
  import DashboardNavbar from './DashboardNavbar.vue';
  import { FadeTransition } from 'vue2-transitions';


  export default {
    components: {
      DashboardNavbar,
      FadeTransition
    },
    data() {
      return {
        sidebarBackground: 'vue' //vue|blue|orange|green|red|primary
      };
    },
    methods: {
      toggleSidebar() {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false);
        }
      }
    }
  };
</script>
<style lang="scss">
</style>
